<template>

    <pending
        :documents-uri="route('api.v1.documents.pending')"
    ></pending>

</template>

<script>

import Pending from "../../components/Documents/Pending";

export default {

    components: {
        Pending,
    },

    metaInfo: {
        title:'Pending Documents',
    },

    name:'DocumentsPending',

}

</script>
